import { Box, Button, Container, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n';

const BULLETS = ['landing.mgmt.b1', 'landing.mgmt.b2', 'landing.mgmt.b3', 'landing.mgmt.b4', 'landing.mgmt.b5'];

export function ForManagement() {
  const t = useT();

  return (
    <Box component="section" id="pengelola" sx={{ bgcolor: 'background.paper', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.05fr 0.95fr' },
            gap: { xs: 4, md: 6 },
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography
              variant="overline"
              sx={{ color: 'secondary.main', fontWeight: 600, letterSpacing: '0.6px' }}
            >
              {t('landing.mgmt.kicker')}
            </Typography>
            <Typography variant="h3" fontWeight={700} sx={{ mt: 1, letterSpacing: '-0.3px' }}>
              {t('landing.mgmt.title')}
            </Typography>
            <List sx={{ mt: 1 }}>
              {BULLETS.map((key) => (
                <ListItem key={key} disableGutters sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 34, color: 'success.main' }}>
                    <CheckRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={t(key)} />
                </ListItem>
              ))}
            </List>
            <Button
              sx={{ mt: 2 }}
              size="large"
              variant="contained"
              color="primary"
              component={Link}
              to="/login"
            >
              {t('landing.mgmt.cta')}
            </Button>
          </Box>

          <Box
            sx={{
              minHeight: { xs: 180, md: 280 },
              borderRadius: 3,
              bgcolor: 'action.hover',
              border: 1,
              borderColor: 'divider',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'text.disabled',
              gap: 1,
            }}
          >
            <DashboardRoundedIcon sx={{ fontSize: 40 }} />
            <Typography variant="caption">{t('landing.mgmt.title')}</Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
